<template>
  <DBox :id="'cmp-distribution-accounts-account_sidewindow-backorders'" :addButton="false" :addLink="false" :rightMenu="[
    {
      text: $t('export'),
      value: 'export'
    }
  ]" @menuClick="onRightMenuClick">
    <NTable class="dbox1" :id="'distribution-accounts-account_sidewindow-backorders'" :headers="headers" :items="list"
      :config="tableConfig" :showNoItems="true">
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('backorders')">
            <span class="txtov ut-link ut-text-accent5" :title="item['catalog_no']">
              {{ item["catalog_no"] }}
            </span>
          </td>
          <td v-bind="tdcon('title_column')">
            <span class="txtov" :title="item['release_title']">
              {{ item["release_title"] }}
            </span>
          </td>
          <td v-bind="tdcon('format_column')">
            <span class="txtov" :title="item['format_name']">
              {{ item["format_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('qty_column')">
            <TextField2 :id="'qty'" :showLabel="false" :disabled="item['disabled']" :value="item['qty']" :ta="'right'"
              :bb="'none'" @blur="e => onTextFieldValueChange(e, item)" />
          </td>
          <td v-bind="tdcon('options')">
            <img src="static/icons/delete.svg" @click.stop="e => onDeleteOrderItem(item)" class="dt-icon v5 s2 ut-center"
              alt="Delete Backorder" title="Delete Backorder" />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import { AccountService } from "../../services/account.service";
import FileDownload from "js-file-download";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionAccountActions } from "../../store/accounts/actions";
import { async } from "ramda-adjunct";
export default {
  components: {
    NTable,
    TextInput
  },
  props: ["selectedAccountsDetails"],
  data: function () {
    return {
      selectedInvoice: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false
      })
    };
  },
  computed: {
    list: function () {
      return this.selectedAccountsDetails.backorders || [];
    },

    headers: function () {
      return [
        createTableHeader("backorders", { f: 0.7, mw: 250 }),
        createTableHeader("title_column", {
          text: this.$t("title")
        }),
        createTableHeader("format_column", {
          text: this.$t("format"),
          mw: 150
        }),
        createTableHeader("qty_column", {
          ta: "right",
          text: this.$t("QTY"),
          mw: 100
        }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    ...mapActionObject(storeNS, distributionAccountActions),
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.backorder_id,
        table: "l_backorders"
      });
      this.updateData(item);
    },
    updateData: function (item) {
      const backorders = this.selectedAccountsDetails.backorders.map(b => {
        if (b.backorder_id === item.backorder_id) {
          b = {
            ...item
          };
        }
        return b;
      });

      this[ActionTypes.DistributionAccountBackOrder.SET.ALL]({
        account_id: this.selectedAccountsDetails?.account?.account_id,
        backorders: backorders || []
      });
    },
    onDeleteOrderItem: async function (item) {
      const confirmationResult = await confirmDelete(
        "Backorder",
        item.release_title
      );
      if (confirmationResult === "OK") {
        const res = await AccountService.deleteBackorder({ ...item });
        const backorders = this.list.filter(
          b => b.backorder_id !== item.backorder_id
        );

        console.log("::::::::::", backorders)


        this[ActionTypes.DistributionAccountBackOrder.SET.ALL]({
          account_id: this.selectedAccountsDetails?.account?.account_id,
          backorders: backorders || []
        });
      }
    },
    onRightMenuClick: async function (menu) {
      if (menu == "export") {
        const res = await AccountService.getExportAccountBackOrder(
          this.selectedAccountsDetails?.account?.account_id
        );
        console.log({ fileURL: res.data });
        FileDownload(res.data, "backorders.xlsx");
      }
    }
  }
};
</script>
